// extracted by mini-css-extract-plugin
export var wrapper = "about-module--wrapper--1UzvN";
export var containerMain = "about-module--containerMain--3aELL";
export var title = "about-module--title--1rB23";
export var desc = "about-module--desc--3pkO5";
export var containerRight = "about-module--containerRight--1lfW7";
export var aboutImg = "about-module--aboutImg--323E_";
export var containerLeft = "about-module--containerLeft--3Qsxt";
export var c = "about-module--c--10vYu";